const lang = {
	EN: {
		onaslink: 'ABOUT US',
		dostpaylink: 'SHIPPING AND PAYMENT',
		contactlink: 'CONTACTS',
		publicofert: 'Public offer',
		politic: 'Privacy Policy',
		nahcompany: 'OUR COMPANY',
		catalogTitile: 'CATALOG',
		see: 'FOLLOW US',
		recvizit: 'REQUISITES',
		individual: 'Individual entrepreneur',
		inn: 'Inn',
		ogrn: 'OGRN',
		bank: 'Bank',
		title: 'Online store selling bags and accessories from Italy'
	},
	'': {
		onaslink: 'О НАС',
		dostpaylink: 'ДОСТАВКА И ОПЛАТА',
		contactlink: 'КОНТАКТЫ',
		publicofert: 'Публичная оферта',
		politic: 'Политика конфиденциальности',
		nahcompany: 'НАША КОМПАНИЯ',
		catalogTitile: 'КАТАЛОГ',
		see: 'СЛЕДИТЕ ЗА НАМИ',
		recvizit: 'РЕКВИЗИТЫ',
		individual: 'Индивидуальный предприниматель',
		inn: 'Инн',
		ogrn: 'ОГРН',
		bank: 'Банк',
		title: 'Интернет-магазин по продаже сумок и аксесуаров из Италии'
	},
	KZ: {
		onaslink: 'БІЗ ТУРАЛЫ',
		dostpaylink: 'ЖЕТКІЗУ ЖӘНЕ ТӨЛЕУ',
		contactlink: 'БАЙЛАНЫСТАР',
		publicofert: 'Жария ұсыныс',
		politic: 'Құпиялылық саясаты',
		nahcompany: 'БІЗДІҢ КОМПАНИЯ',
		catalogTitile: 'КАТАЛОГ',
		see: 'БІЗГЕ ЖАЗЫЛУ',
		recvizit: 'ТОЛЫҚТАР',
		individual: 'Жеке кәсіпкер',
		inn: 'қонақхана',
		ogrn: 'OGRN',
		bank: 'Банк',
		title: 'Италиядан келген сөмкелер мен аксессуарларды сататын интернет-дүкен'
	},
	ARM: {
		onaslink: 'ՄԵՐ ՄԱՍԻՆ',
		dostpaylink: 'ԱՌԱՔՈՒՄ ԵՎ ՎՃԱՐՈՒՄ',
		contactlink: 'ԿՈՆՏԱԿՏՆԵՐ',
		publicofert: 'Հրապարակային առաջարկ',
		politic: 'Գաղտնիության քաղաքականություն',
		nahcompany: 'ՄԵՐ ԸՆԿԵՐՈՒԹՅՈՒՆԸ',
		catalogTitile: 'ԿԱՏԱԼՈԳ',
		see: 'ՀԵՏԵՎԵՔ ՄԵԶ',
		recvizit: 'ՄԱՆՐԱՄԱՍՆԵՐ',
		individual: 'Անհատ ձեռնարկատեր',
		inn: 'TIN',
		ogrn: 'OGRN',
		bank: 'Բանկ',
		title: 'Իտալիայից պայուսակներ և աքսեսուարներ վաճառող առցանց խանութ'
	}
};

export { lang };
